import type { ComponentProps } from 'react';
import type { SignIn } from '@clerk/clerk-react';

/**
 * Matches Clerk's prebuilt <SignIn>/<SignUp> to this app's design system
 * (brand yellow accent #FFC800, dark text on white, generously rounded
 * corners -- see packages/ui/tailwind.preset.ts) via Clerk's supported
 * `appearance` theming API rather than forking/rebuilding the auth UI.
 * Typed off the component's own prop instead of importing an `Appearance`
 * type name directly -- @clerk/clerk-react does not re-export one at a
 * stable path across versions, and this stays correct regardless.
 */
export const clerkAppearance: ComponentProps<typeof SignIn>['appearance'] = {
  variables: {
    colorPrimary: '#FFC800',
    colorText: '#1A1A1A',
    colorBackground: '#FFFFFF',
    borderRadius: '1rem',
  },
  elements: {
    card: 'shadow-xl rounded-2xl border border-gray-100',
    formButtonPrimary: 'bg-brand text-brand-foreground hover:bg-brand/90 focus:shadow-none',
    footerActionLink: 'text-brand-foreground font-semibold hover:text-brand',
  },
};
